<app-widget *ngIf="currentTopic" [content]="currentTopic.body"></app-widget>
